import { getData } from '@/packages/namba-metrics/helpers'

import { api } from '@/shared/api/rest'
import { SendAppEventParams } from '@/shared/api/rest/types'

export type NambaMetricaPayload = Record<string, unknown>

export async function sendAppData(payload?: NambaMetricaPayload) {
    try {
        await api.sendAppData(getData(payload))
    } catch (e: unknown) {
        throw new Error(e as string)
    }
}

export async function sendAppEvent(payload?: NambaMetricaPayload) {
    try {
        await api.sendAppEvent(getData(payload) as SendAppEventParams)
    } catch (e) {
        throw new Error(e as string)
    }
}

const MAX_REQUESTS_COUNT = 3
const RETRY_DELAY = 3000

const sleep = (ms: number) => new Promise<void>(r => setTimeout(r, ms))

async function sendWithRetry(
    fn: (payload: NambaMetricaPayload) => Promise<void>,
    payload: NambaMetricaPayload
) {
    let attempt = 0

    while (attempt < MAX_REQUESTS_COUNT) {
        attempt += 1
        try {
            await fn(payload)
            return true
        } catch {
            if (attempt >= MAX_REQUESTS_COUNT) return false
            await sleep(RETRY_DELAY)
        }
    }

    return false
}

export const sendAppDataWithRetry = (payload: NambaMetricaPayload) =>
    sendWithRetry(sendAppData, payload)
export const sendAppEventWithRetry = (payload: NambaMetricaPayload) =>
    sendWithRetry(sendAppEvent, payload)
